import React from "react";
import sendicon from "./img/sendicon.png"
import "./input.css";

const Input = ({ message, updateMessage, sendMessage,passref }) => {
  return (
    <form className="input_form" ref={passref}>
      <input
        className="input"
        type="text"
        placeholder="type a message..."
        value={message}
        onChange={(event) => updateMessage(event.target.value)}
        onKeyPress={(event) =>
          /Enter/.test(event.key) ? sendMessage(event) : null
        }
      />

      <img src={sendicon} alt="send" className="sendButton" onClick={(event) => sendMessage(event)}/>
    </form>
  );
};
export default Input;
